import { useEffect } from "react";
import { Reveal, Eyebrow } from "../lib/data";

const LegalPage = ({ title, updated, sections, pageKey }) => {
  useEffect(() => {
    document.title = `${title} | MEDAS Dental Point Timișoara`;
  }, [title]);

  return (
    <div className="pt-[76px] md:pt-[112px]" data-testid={`${pageKey}-page`}>
      <section className="py-16 lg:py-20 bg-white medical-grid">
        <div className="max-w-3xl mx-auto px-6">
          <Reveal>
            <Eyebrow>Legal</Eyebrow>
            <h1 className="font-display text-4xl font-extrabold tracking-tight text-[#2A2521] mt-3">{title}</h1>
            <p className="text-sm text-[#8A7A5E] mt-3">Ultima actualizare: {updated}</p>
          </Reveal>
          <div className="mt-10 space-y-9">
            {sections.map((s, i) => (
              <Reveal key={s.heading} delay={i * 0.03}>
                <h2 data-testid={`${pageKey}-section-${i}`} className="font-display text-xl font-bold text-[#2A2521]">
                  {i + 1}. {s.heading}
                </h2>
                {s.paragraphs.map((p, j) => (
                  <p key={j} className="text-[#4A3F2E] mt-3 leading-relaxed text-[15px]">{p}</p>
                ))}
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPage;
